//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  SfTable,
  SfButton,
  SfProperty,
  SfLink
} from '@storefront-ui/vue';
import Paginate from '~/components/Paginate';
import { useDistributor } from '@bee-hole/coms';
import { computed, ref, onMounted } from '@nuxtjs/composition-api';
export default {
  components: {
    SfTable,
    SfButton,
    SfProperty,
    SfLink,
    Paginate
  },
  props: {
    fxId: {
      type: Number
    }
  },
  setup(props, context) {
    const getCuurentDate = context?.root?.$options?.getCuurentDate;
    const QueryParams = ref({ page: 1, limit: 10, distributor_id: props.fxId });
    const { list, distributorOrderList } = useDistributor();
    const orderTotal = computed(() => list?.value?.total_count);
    const totalPageNo = computed(() => Math.ceil(orderTotal.value / QueryParams.value.limit) || 1);
    const statusList = ref({
      1: 'distributor.status.1',
      2: 'distributor.status.2',
      3: 'distributor.status.3',
      4: 'distributor.status.4'
    });
    onMounted(async () => {
      await distributorOrderList(QueryParams.value);
    });
    const changePageNo = async (page_no) => {
      QueryParams.value.page = page_no;
      await distributorOrderList(QueryParams.value);
    };
    return {
      totalPageNo,
      orderTotal,
      OrderList: computed(() => list.value?.list || []),
      changePageNo,
      QueryParams,
      getCuurentDate,
      statusList
    };
  }
};
